var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('admin.title')))]),_c('Descriptions'),_c('Experience'),_c('Curriculums'),_c('Projects'),_c('Social'),_c('Redirects')],1)}
var staticRenderFns = []

export { render, staticRenderFns }